import React, { Component, createRef } from 'react';
import './mobileTicket.scss';
import { connect } from 'react-redux';
import MobileFlightSection from './mobileFlightSection';
import PassengerInfo from './passengerSection';
import PriceSection from './priceSection';
import TicketButtons from './ticketButtons';
class MobileTicket extends Component {
  constructor() {
    super();
    this.state = { currentFlightIndex: 0, node: null };
    this.print = createRef(null);
  }
  componentDidUpdate = () => {};
  render() {
    let {
      currentFlight,
      parsedQueryStr,
      // printWithCss,
      // name,
      // direction,
      // renderTicketContainer,
    } = this.props;
    return (
      <div className="d-flex w-100 justify-content-center">
        <div
          className="col-11 col-sm-10 col-md-10 col-lg-3 col-xl-3 m-0 p-0 d-flex flex-column rounded-lg overflow-hidden touchAction-none"
          style={{ background: 'none' }}
        >
          <div id="myDoc" className="d-flex w-100 h-100 flex-column">
            <div className="">
              <TicketButtons
                refrence={this.props.refrence}
                id={currentFlight?._id}
              />
            </div>
            <div style={{ direction: this.props.direction }}>
              <div className="d-flex w-100 mt-4 ">
                <PassengerInfo
                  position-relative
                  w-100
                  d-flex
                  justify-content-center
                  align-items-center
                  rounded-lg
                  overflow-hidden
                  currentFlight={currentFlight}
                  currentFlightIndex={this.state.currentFlightIndex}
                  id={parsedQueryStr.id}
                />
              </div>

              <div className="d-flex w-100 ">
                <MobileFlightSection
                  currentFlight={currentFlight}
                  changeFlightIndex={(index) => {
                    this.setState({ currentFlightIndex: index });
                  }}
                />
              </div>
              <div className="py-2">
                <PriceSection />
              </div>
            </div>
          </div>
          {/* <div className="d-flex w-100 justify-content-around mt-3 cursor-pointer">
            <i
              className="far fa-print text-secondary font-huge"
              onClick={() => {
                {
                  let htmltag = renderTicketContainer(
                    currentFlight,
                    name,
                    direction
                  );

                  document.body.appendChild(htmltag);
                }
                printWithCss();
              }}
            />
            <i
              className="far fa-download text-primary font-huge"
              onClick={() => this.downLoadPDF()}
            />
        
          </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { direction: state.language.direction };
};
export default connect(mapStateToProps)(MobileTicket);
